import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var MergeFieldsIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("rect", {
    x: "8",
    y: "4.97",
    width: "11",
    height: "14",
    rx: "1.57",
    fill: "none"
  }), /*#__PURE__*/_jsx("path", {
    d: "M5.28,4H4A1,1,0,1,0,4,6H5V5A2,2,0,0,1,5.28,4Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M4,16a1,1,0,0,0,0,2H5V16Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M4,10a1,1,0,0,0,0,2H5V10Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M19,3H7A2,2,0,0,0,5.28,4H6A1,1,0,1,1,6,6h.5a.5.5,0,0,1,0,1H5v3H6a1,1,0,0,1,0,2h.5a.5.5,0,0,1,0,1H5v3H6a1,1,0,0,1,0,2h.5a.5.5,0,0,1,0,1H5a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V5A2,2,0,0,0,19,3ZM19,17.4A1.57,1.57,0,0,1,17.43,19H9.57A1.57,1.57,0,0,1,8,17.4V6.55A1.57,1.57,0,0,1,9.57,5h7.86A1.57,1.57,0,0,1,19,6.55Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M7,5A1,1,0,0,0,6,4H5.28A2,2,0,0,0,5,5V6H6A1,1,0,0,0,7,5Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M7,17a1,1,0,0,0-1-1H5v2H6A1,1,0,0,0,7,17Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M7,11a1,1,0,0,0-1-1H5v2H6A1,1,0,0,0,7,11Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M13.14,14.6l-.36-.92H10.57l-.36.92h-1l1.9-4.83h1l1.9,4.83Zm-1.46-4-.87,2.3h1.74Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M16.75,14.6v-.37a1.5,1.5,0,0,1-1.13.46,1.16,1.16,0,0,1-1.22-1.16,1.13,1.13,0,0,1,1.22-1.14,1.48,1.48,0,0,1,1.13.45v-.52c0-.4-.34-.65-.82-.65a1.44,1.44,0,0,0-1,.44l-.31-.53A2.1,2.1,0,0,1,16.05,11c.78,0,1.46.32,1.46,1.27V14.6Zm0-.79v-.53a1,1,0,0,0-.84-.36.63.63,0,1,0,0,1.25A1,1,0,0,0,16.75,13.81Z"
  })]
}), 'MergeFieldsIcon');